import GetUserInfo from "../Screens/authenticatie/GetUserInfo"

export const Role = {
  Besteller: 'Besteller',
  Gebruikersbeheerder: 'Gebruikersbeheerder',
  Leerkracht: 'Leerkracht',
  Aanvrager: 'aanvrager'
};

export function authService() {
  return {
    currentUser: () => GetUserInfo() || null,
    logout: () => {
      sessionStorage.removeItem('jwt');
      sessionStorage.removeItem('refresh');
    }
  };
}
